import { useRoutes } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useAppSelector } from "hooks";

// routes
import { buildMainRoutes, CHILDREN } from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const user = useAppSelector((state) => state.user);
    const [mainRoutes, setMainRoutes] = useState({});

    useEffect(() => {
        const children = CHILDREN.filter(children => {
            if (!children.authority) return true;

            return !!user.info?.roles.includes(children.authority);
        })

        const routes = buildMainRoutes(children);
        setMainRoutes(routes);
    }, [user])

    return useRoutes([mainRoutes, AuthenticationRoutes]);
}
